import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {Store} from '@ngrx/store';
import {catchError, map, of, switchMap, withLatestFrom} from 'rxjs';
import {selectSelectedOrganizationId} from '../../state/router/router.selectors';
import {OrganizationActions} from './organization.actions';
import {StoreApiService} from '../../services/store-api.service';

@Injectable()
export class OrganizationEffects {
  loadOrganizationName$ = createEffect(() =>
    this.actions$.pipe(
      ofType(OrganizationActions.loadOrganizationName),
      withLatestFrom(this.store.select(selectSelectedOrganizationId)),
      switchMap(([, organizationId]) =>
        this.storeApi.getSupplierName(`sportsengine-vendor-${organizationId}`).pipe(
          map(organizationName => OrganizationActions.loadOrganizationNameSuccess({organizationName})),
          catchError(() => {
            return of(
              OrganizationActions.loadOrganizationNameFailure({
                error: {message: 'An error occurred, please refresh and try again.'},
              })
            );
          })
        )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private store: Store,
    private storeApi: StoreApiService
  ) {}
}
